import '@fontsource-variable/red-hat-display/index.css';
import './index.css';

import { OfflineIndicator, UpdateNotification } from '@components/ServiceWorker';
import { Toaster } from '@components/ui/molecules/Toast';
import { ApolloProvider } from '@shared/apollo/ApolloProvider';
import { AuthProvider } from '@shared/auth';
import { ChakraProvider } from '@shared/chakra';
import errorTracker from '@shared/errorTracking/errorTracker';
import { JotaiRoot } from '@shared/jotai';
import { guardDomAgainstTranslation } from '@shared/react/guardDomAgainstTranslation';
import { AppRouter } from '@shared/router';
import { registerServiceWorker } from '@shared/serviceWorker';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { Routes } from './Routes';

errorTracker.init();
guardDomAgainstTranslation();

// Register service worker
registerServiceWorker({
  onUpdateAvailable: () => {
    console.log('Service worker update available.');
  },
  onUpdateReady: () => {
    console.log('Service worker update ready.');
  },
  onOffline: () => {
    console.log('App is offline.');
  },
  onOnline: () => {
    console.log('App is back online.');
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApolloProvider>
      <HelmetProvider>
        <ChakraProvider>
          <JotaiRoot>
            <AuthProvider>
              <AppRouter>
                <UpdateNotification />
                <OfflineIndicator />
                {/* <InstallPrompt /> */}
                <Toaster />
                <Routes />
              </AppRouter>
            </AuthProvider>
          </JotaiRoot>
        </ChakraProvider>
      </HelmetProvider>
    </ApolloProvider>
  </StrictMode>
);
